var map = {
	".": "cId4",
	"./": "cId4",
	"./00_get_account_balance": "HY4c",
	"./00_get_account_balance.json": "HY4c",
	"./02_get_asset_transfer2": "gp5h",
	"./02_get_asset_transfer2.json": "gp5h",
	"./07_post_capital_innerTransfer_apply": "KPNz",
	"./07_post_capital_innerTransfer_apply.json": "KPNz",
	"./08_post_asset_transfer_new": "kbpg",
	"./08_post_asset_transfer_new.json": "kbpg",
	"./09_get_account_transfer_support_coin": "IyO2",
	"./09_get_account_transfer_support_coin.json": "IyO2",
	"./10_get_asset_transfer_record": "oyKG",
	"./10_get_asset_transfer_record.json": "oyKG",
	"./11_get_fund_account_balance": "5M3S",
	"./11_get_fund_account_balance.json": "5M3S",
	"./14.get_wallet_queryInnerTransferRecords": "9tS2",
	"./14.get_wallet_queryInnerTransferRecords.json": "9tS2",
	"./21_get_account_allAccountBalance": "Exaw",
	"./21_get_account_allAccountBalance.json": "Exaw",
	"./index": "cId4",
	"./index.js": "cId4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/Z+/";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/api/account ^.*$
// module id = /Z+/
// module chunks = 3